import { Injectable } from '@angular/core';
import { Visitor } from '@enliven/angular';
import { VisitorPayload } from '../models/visitor-payload.model';
import { VisitorApiPayload } from '../models/visitor-api-payload.model';
import { VisitorApiResponse } from '../models/visitor-api-response.model';

@Injectable({
  providedIn: 'root'
})
export class VisitorSerializer {
  toApiPayload(payload: VisitorPayload): VisitorApiPayload {
    const { appName, email, firstName, lastName, username } = payload;
    return {
      app_name: appName,
      email,
      first_name: firstName,
      last_name: lastName,
      username
    };
  }

  fromApiResponse(response: VisitorApiResponse): Visitor {
    const { created, enrolled, matched_by, organization_external_id, organization_name, visitor_id } = response;
    return {
      visitorId: visitor_id,
      created,
      enrolled,
      matchedBy: matched_by,
      organizationExternalId: organization_external_id,
      organizationName: organization_name
    };
  }
}
